var _path, _path2, _mask, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinessMarketing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.4688 57H8.53125C7.686 57 7 56.314 7 55.4688C7 54.6235 7.686 53.9375 8.53125 53.9375H54.4688C55.314 53.9375 56 54.6235 56 55.4688C56 56.314 55.314 57 54.4688 57Z",
    fill: "#2E61A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 55.5H57",
    stroke: "#2E61A1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 19C43.8954 19 43 19.8954 43 21V51H57V21C57 19.8954 56.1046 19 55 19H45ZM25 29C25 27.8954 25.8954 27 27 27H37C38.1046 27 39 27.8954 39 29V51H25V29ZM7 37C7 35.8954 7.89543 35 9 35H19C20.1046 35 21 35.8954 21 37V51H7V37Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 19C43.8954 19 43 19.8954 43 21V51H57V21C57 19.8954 56.1046 19 55 19H45ZM25 29C25 27.8954 25.8954 27 27 27H37C38.1046 27 39 27.8954 39 29V51H25V29ZM7 37C7 35.8954 7.89543 35 9 35H19C20.1046 35 21 35.8954 21 37V51H7V37Z",
    fill: "#2E61A1",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43 51H39V55H43V51ZM57 51V55H61V51H57ZM39 51V55H43V51H39ZM25 51H21V55H25V51ZM21 51V55H25V51H21ZM7 51H3V55H7V51ZM47 21C47 22.1046 46.1046 23 45 23V15C41.6863 15 39 17.6863 39 21H47ZM47 51V21H39V51H47ZM57 47H43V55H57V47ZM53 21V51H61V21H53ZM55 23C53.8954 23 53 22.1046 53 21H61C61 17.6863 58.3137 15 55 15V23ZM45 23H55V15H45V23ZM27 23C23.6863 23 21 25.6863 21 29H29C29 30.1046 28.1046 31 27 31V23ZM37 23H27V31H37V23ZM43 29C43 25.6863 40.3137 23 37 23V31C35.8954 31 35 30.1046 35 29H43ZM43 51V29H35V51H43ZM25 55H39V47H25V55ZM21 29V51H29V29H21ZM9 31C5.68629 31 3 33.6863 3 37H11C11 38.1046 10.1046 39 9 39V31ZM19 31H9V39H19V31ZM25 37C25 33.6863 22.3137 31 19 31V39C17.8954 39 17 38.1046 17 37H25ZM25 51V37H17V51H25ZM7 55H21V47H7V55ZM3 37V51H11V37H3Z",
    fill: "#2E61A1",
    mask: "url(#path-3-inside-1)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29 8H35V14",
    stroke: "#2E61A1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19 23L35 8",
    stroke: "#2E61A1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessMarketing);
export default __webpack_public_path__ + "static/media/business_marketing.0fb5894207e4d5fefe9ffb1ccf055ea8.svg";
export { ForwardRef as ReactComponent };